import React, { Component } from 'react';
import './StickyNotification.css';

class StickyNotification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: true,
    };
  }

  handleClose = () => {
    this.setState({ visible: false });
  };

  render() {
    if (!this.state.visible) return null;

    const { message, ctaText, ctaLink, icon } = this.props;

    return (
      <div className="sticky-notification-container">
        <div className="sticky-notification-content">
          <span className="sticky-notification-icon">{icon || '📢'}</span>
          <span className="sticky-notification-text">{message || 'Download the MentoMeet App for the best experience!'}</span>
        </div>
        {ctaText && ctaLink && (
          <a href={ctaLink} className="sticky-notification-cta-button">
            {ctaText}
          </a>
        )}
        <button
          className="sticky-notification-close-button"
          onClick={this.handleClose}
          title="Close notification"
        >
          ×
        </button>
      </div>
    );
  }
}

export default StickyNotification;

